import React, { useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';
import { useSelector, useDispatch } from 'react-redux';
import {
    faUser,
    faUsers,
    faCalendarCheck,
    faCalendarDays,
    faClockRotateLeft,
    faArrowsRotate,
} from '@fortawesome/free-solid-svg-icons';
import StatusCard from 'components/StatusCard';
import TableCard from 'components/TableCard';
import 'assets/styles/account.css';

const getCycleLabel = (subscription) => [1, 2, 3]
    .filter((index) => subscription && subscription[`cycle_${index}`] === 1)
    .map((index) => `Cycle ${index}`)
    .join(', ');

export default function AccountPage() {
    const user = useSelector(state => state.userGlobal.user);
    const savedUsers = useSelector(state => state.userDetail.arr);
    const savedSubscription = useSelector(state => state.userAbo.user || state.userAbo.abo);
    const [userInfo, setUserInfo] = useState(savedUsers[0] && savedUsers[0].id_user ? savedUsers : []);
    const [userAbo, setUserAbo] = useState(savedSubscription || []);
    const [cycle, setCycle] = useState(getCycleLabel(savedSubscription));
    const dispatch = useDispatch();

    React.useEffect(() => {
        axios.get(`https://eps.acces-editions.com/api/showUser?id_compte=${user.id_compte}`)
            .then((res) => {
                if (res.data.allPseudo[0] !== undefined && res.data.allPseudo[0].pseudo) {
                    dispatch({ type: 'user/userDetail', payload: res.data.allPseudo });
                    setUserInfo(res.data.allPseudo);
                }
            });

        const formData = new FormData();
        formData.append('id_compte', user.id_compte);

        axios.post('https://eps.acces-editions.com/api/statutAbonnement', formData)
            .then((res) => {
                if (res.data[0] !== undefined && res.data[0].id_type_abonnements) {
                    dispatch({ type: 'user/userAbo', payload: res.data[0] });
                    setUserAbo(res.data[0]);

                    setCycle(getCycleLabel(res.data[0]));
                }
            });
    }, [user.id_compte, dispatch]);

    const remainingDays = userAbo.date_fin ? moment(userAbo.date_fin).diff(moment(), 'days') : null;
    const remainingLabel = remainingDays === null
        ? ''
        : remainingDays <= 0 ? 'Abonnement expiré' : `${remainingDays}j`;

    return (
        <main className="ae-account-page">
            <div className="ae-account-ring ae-account-ring--violet" />
            <div className="ae-account-ring ae-account-ring--green" />
            <div className="ae-account-ring ae-account-ring--gold" />

            <div className="ae-account-content">
                <header className="ae-account-heading">
                    <h1>Mon compte</h1>
                    <p>Gérez votre compte et vos abonnements en toute simplicité.</p>
                </header>

                <section className="ae-account-stat-grid" aria-label="Informations du compte">
                    <StatusCard
                        color="pink"
                        icon={faUser}
                        title="Compte"
                        amount={user.email || ''}
                    />
                    <StatusCard
                        color="orange"
                        icon={faUsers}
                        title={userInfo.length > 1 ? "Nombre d'utilisateurs" : "Nombre d'utilisateur"}
                        amount={userInfo.length !== undefined ? userInfo.length.toString() : ''}
                    />
                    <StatusCard
                        color="purple"
                        icon={faCalendarCheck}
                        title="Date début d'abonnement"
                        amount={userAbo.date_debut ? moment(userAbo.date_debut).format('DD MMMM YYYY') : ''}
                    />
                    <StatusCard
                        color="blue"
                        icon={faCalendarDays}
                        title="Date de fin"
                        amount={userAbo.date_fin ? moment(userAbo.date_fin).format('DD MMMM YYYY') : ''}
                    />
                    <StatusCard
                        color="green"
                        icon={faClockRotateLeft}
                        title="Durée restante"
                        amount={remainingLabel}
                    />
                    <StatusCard
                        color="yellow"
                        icon={faArrowsRotate}
                        title="Cycles d'abonnement"
                        amount={cycle || ''}
                        wide
                    />
                </section>

                <section className="ae-account-users-area">
                    <TableCard />
                </section>

                <footer className="ae-account-copyright">© 2024 Accès EPS — Tous droits réservés</footer>
            </div>
        </main>
    );
}
